// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1FOq4","colMin":"styles_colMin__uTlTQ","colCheckbox":"styles_colCheckbox__lL0k1"};